import React from 'react';
import { AddEntityButton } from '@/shared/components/AddEntityButton';
import { FormField } from '@/shared/components/GenericFormDialog';
import { useCraftsmen } from '../hooks/useCraftsmen';
import { CraftsmanInsert } from '@/features/masters/types';

/**
 * 職人追加ボタンコンポーネント（新版）
 * 汎用AddEntityButtonを使用した実装
 */
export const AddCraftsmanButton: React.FC = () => {
  const { createEntity, isLoading, craftsmanTypes } = useCraftsmen();

  // フォームフィールドの定義
  const fields: FormField[] = [
    {
      key: 'name',
      label: '氏名',
      type: 'text',
      required: true,
      placeholder: '山田 太郎',
    },
    {
      key: 'daily_rate',
      label: '日単価 (円)',
      type: 'number',
      required: false,
      placeholder: '例: 20000',
      min: 0,
    },
    {
      key: 'craftsman_type',
      label: '職人種別',
      type: 'select',
      required: false,
      options: craftsmanTypes.map((type: string) => ({
        value: type,
        label: type,
      })),
    },
    {
      key: 'is_active',
      label: '在籍状態',
      type: 'switch',
      required: false,
      placeholder: 'この職人が現在在籍しているかを示します。',
    },
  ];

  /**
   * フォーム送信処理
   * @param data フォームデータ
   */
  const handleSubmit = async (data: Partial<Record<string, unknown>>) => {
    const craftsmanData = {
      tenant_id: 'default-tenant',
      name: data.name as string,
      craftsman_type_id: data.craftsman_type_id as string | null,
      daily_rate: data.daily_rate as number | null,
      is_active: data.is_active as boolean ?? true,
    } as CraftsmanInsert;
    await createEntity(craftsmanData);
  };

  return (
    <AddEntityButton
      entityName="職人"
      fields={fields}
      onSubmit={handleSubmit}
      isLoading={isLoading}
    />
  );
};